import classNames from 'classnames';
import React, { FunctionComponent } from 'react';

import { styled } from '../../styled-components';

import styles from './Icon.module.scss';
import { IconColor } from './IconColor';

import { IconFa } from './IconFa';
import { IconSize } from './IconSize';

export interface IconProps {
  name: string;
  fa?: IconFa;
  spin?: boolean;
  inverse?: boolean;
  color?: IconColor | string;
  size?: IconSize | number;
}

const IconDefaultProps = {
  fa: IconFa.Fal,
  spin: false,
  inverse: false,
  name: 'chevron-right',
  color: IconColor.Default,
  size: IconSize.Default,
};

const IStyled = styled.i`
  line-height: inherit;
`;

const Icon: FunctionComponent<IconProps> = ({ fa, spin, inverse, name, color, size }: IconProps) => {
  const isCustomColor = !Object.keys(IconColor)
    .map(key => IconColor[key])
    .includes(color);
  const isCustomSize = !Object.keys(IconSize)
    .map(key => IconSize[key])
    .includes(size);

  const styleColor = color && !isCustomColor ? styles[`color-${color}`] : null;
  const styleSize = size ? styles[`size-${size}`] : null;

  const iconName = name.slice(0, 3) === 'fa-' ? name : `fa-${name}`;

  const customStyles: any = {};
  if (isCustomSize) {
    customStyles.fontSize = size;
  }
  if (isCustomColor) {
    customStyles.color = color;
  }

  if (fa) {
    return (
      <IStyled
        className={classNames(`${fa} ${iconName}`, styleColor, styleSize, {
          'fa-spin': spin,
          'fa-inverse': inverse,
        })}
        aria-hidden="true"
        style={customStyles}
      />
    );
  }
  return null;
};

Icon.defaultProps = IconDefaultProps;

export { Icon };
